import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {BaseService} from './base.service';
import {SettingsService} from './settings.service';
import {DigitalCaseflowLog, DigitalCaseflowLogAdapter} from "@secca/shared/models/digital-caseflow-log";
import { KeycloakService } from 'keycloak-angular';
import { EventSourcePolyfill } from 'event-source-polyfill';

@Injectable({
  providedIn: 'root',
})
export class DigitalCaseflowService extends BaseService {
  constructor(
    private http: HttpClient,
    private digitalCaseflowFlowLogAdapter: DigitalCaseflowLogAdapter,
    private settingsService: SettingsService,
    private keycloakService: KeycloakService
  ) {
    super(settingsService);
  }

  getDigitalCaseflowLog(digitalCaseflowLogId: number): Observable<DigitalCaseflowLog> {
    return this.http
      .get(this.baseURL + 'dcf/log/' + digitalCaseflowLogId)
      .pipe(map(item => this.digitalCaseflowFlowLogAdapter.adapt(item)));
  }

  resumeDigitalCaseflow(digitalCaseflowLogId: number): Observable<void> {
    return this.http.post<void>(this.baseURL + 'dcf/log/' + digitalCaseflowLogId + '/resume', {});
  }

  subscribeToCompletion(digitalCaseflowLogId: number): Observable<void> {
    const token = this.keycloakService.getKeycloakInstance().token;
    return new Observable(observer => {
      const url = this.baseURL + 'dcf/log/' + digitalCaseflowLogId + '/subscription';
      console.log('Subscribing to digital caseflow completion at:', url);
      try {
        const eventSource = new EventSourcePolyfill(url, {
          headers: {
            Authorization: 'Bearer ' + token
          },
          heartbeatTimeout: 300000 // 5 minutes
        });

        eventSource.addEventListener('finished', (event: any) => {
          console.log('Digital caseflow finished:', event.data);
          observer.next();
        });

        eventSource.addEventListener('error', (event: any) => {
          console.error('Digital caseflow error:', event.data);
          observer.error(event.data);
        });

        eventSource.onerror = (error) => {
          console.error('EventSource error for', url, ':', error);
          observer.error(error);
        };

        return () => {
          console.log('Closing EventSource for', url);
          eventSource.close();
        };
      } catch (e) {
        console.error('Failed to create EventSourcePolyfill', e);
        observer.error(e);
      }
    });
  }

}
